import React from "react";
import hero from "../assets/images/hero.png";
import cv from "../assets/download/Frontend_Firhan_Ramadhan_CV.pdf";
import facebook from "../assets/icon/facebook.svg";
import github from "../assets/icon/github.svg";
import linkedIn from "../assets/icon/linkedin.svg";
import twitter from "../assets/icon/twitter.svg";

const styles = {
  backgroundImage: "linear-gradient(#D31027, #EA384D)",
};

const icons = [
  {
    src: facebook,
    href: "https://www.facebook.com/Iyankboy/",
    title: "Facebook",
  },
  {
    src: github,
    href: "https://github.com/firhanram",
    title: "Github",
  },
  {
    src: linkedIn,
    href: "https://www.linkedin.com/in/firhan-ramadhan-49414b198/",
    title: "LinkedIn",
  },
  {
    src: twitter,
    href: "https://twitter.com/Ramadhan_Firhan",
    title: "Twitter",
  },
];

const Hero = () => {
  const renderedIcon = icons.map(({ src, href, title }) => {
    return (
      <a href={href} key={title} className="px-1">
        <img src={src} alt={title} className="w-6" />
      </a>
    );
  });

  return (
    <div
      className="flex flex-col md:flex-row lg:flex-row items-center lg:px-20 lg:justify-center md:px-10 pt-20 xl:pt-0 pb-8 xl:pb-0 bg-gray-200 xl:h-screen"
      id="home"
    >
      <img
        src={hero}
        alt="hero"
        className="w-3/4 md:w-1/2 lg:w-1/3 md:order-2 lg:order-2"
      />
      <div className="font-montserrat md:w-1/2 lg:w-2/3 text-center lg:text-left mt-6 md:order-1 lg:order-1 lg:mr-10">
        <div className="leading-tight">
          <h2 className="font-semibold text-lg">Hello, I'm</h2>
          <h1 className="font-semibold text-3xl xl:text-5xl">
            Firhan Ramadhan
          </h1>
          <h3 className="font-light text-sm">Front End Web Developer</h3>
        </div>
        <a href={cv} download>
          <button
            className="px-8 py-2 text-white font-semibold rounded shadow mt-5"
            style={styles}
          >
            MY CV
          </button>
        </a>
        <div className="flex justify-center lg:w-full lg:justify-start mt-5">
          {renderedIcon}
        </div>
      </div>
    </div>
  );
};

export default Hero;
